import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  
  transform(url:string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Pipes/safe.pipe.ts